export enum ParticipantType {
  User = 1,
  InvitedUser = 2,
  Invited = 3
}
